import PaidFeatureIcon from './PaidFeatureIcon';

export default PaidFeatureIcon;
